module.exports = __webpack_public_path__ + "static/img/11-1.57e84f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/events/11-1.png
// module id = rHmy
// module chunks = 1